import styled from 'styled-components'

export const FormWrapper = styled.div`
  width: 600px;
  max-width: 100%;
  padding: 1rem;
  margin: 0 auto;
`

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
`

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.success};
  margin-bottom: 0.5rem;
`

export const SuccessTitle = styled.h3`
  color: ${({ theme }) => theme.colors.success};
  font-weight: 600;
  margin-bottom: 0.5rem;
`

export const SuccessMessage = styled.p`
  color: ${({ theme }) => theme.colors.neutral.low.medium};
  margin-bottom: 1rem;
`
